<template>
  <div>
    <h3>c2c账单</h3>
    <el-table :data="billList">
      <el-table-column label="时间">
        <template slot-scope="scope">
          <span>{{scope.row.businessTime | moment}}</span>
        </template>
        </el-table-column>
        <el-table-column
          label="币种"
          prop="coinType">
        </el-table-column>
        <el-table-column
          label="收支"
          prop="availableAmountChange">
        </el-table-column>
        <el-table-column
          label="冻结余额变更"
          prop="frozenAmountChange">
        </el-table-column>
      </el-table>
      <div class="user-withdrawal-pager-wrap">
        <pagination
          :size="billPagination.size"
          :page="billPagination.page"
          :total="billTotal"
          @pageChanged="handleCurrentChange"
          >
        </pagination>
      </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Pagination from 'components/pagination';

export default {
  name: 'bills',
  props: ['uid'],
  data() {
    return {
    };
  },
  computed: {
    ...mapState('merchantAudit', [
      'billList',
      'billTotal',
      'billPagination'
    ])
  },
  components: {
    Pagination
  },
  methods: {
    ...mapActions('merchantAudit', [
      'getBillList',
      'resetUserRecords',
      'getUserWallet'
    ]),
    getList(data) {
      this.getBillList({
        userId: this.uid,
        ...this.billPagination,
        ...data
      });
    },
    handleCurrentChange(pagination) {
      this.getList(pagination);
    }
  },
  mounted() {
    this.getList();
  },
};
</script>
